import React from 'react';

export default class ProjectTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      title: props.project?.title || '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.project?.title !== this.props.project?.title) {
      this.setState({ title: this.props.project?.title || '' });
    }
  }

  handleBlur = async () => {
    const next = (this.state.title || '').trim();
    const current = (this.props.project?.title || '').trim();
    if (!next || next === current) return;
    try {
      await this.props.onUpdateTitle?.(next);
    } catch {
      // revert on failure
      this.setState({ title: this.props.project?.title || '' });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.currentTarget.blur(); // triggers handleBlur
    } else if (e.key === 'Escape') {
      // revert without saving
      this.setState({ title: this.props.project?.title || '' }, () => {
        e.currentTarget.blur();
      });
    }
  };

  render() {
    const { project, disabled } = this.props;
    const isArchived = !!project?.archived_at;
    const isDisabled = !!disabled || isArchived;

    return (
        <div
          className={`project-header${isArchived ? ' is-archived' : ''}`}
          aria-disabled={isDisabled || undefined}
        >
          <div className="project-identity">

          <div className="project-text">
              <div className="project-title-progress-row">
                <input
                  disabled={isDisabled}
                  readOnly={isDisabled}
                  className={`project-title${isDisabled ? ' readonly' : ''}`}
                  value={this.state.title}
                  onChange={(e) => this.setState({ title: e.target.value })}
                  onBlur={this.handleBlur}
                  onKeyDown={this.handleKeyDown}
                  aria-label="Project title"
                  title={
                    isArchived
                      ? 'Archived — use the ⋮ actions to restore before editing'
                      : 'Edit project title'
                  }
                />
              </div>

            {isArchived && (
              <div className="archived-hint">
                View-only. Use the <strong>⋮</strong> menu to restore and make changes.
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
